import { STATUS_BADGE_STYLES } from "@/features-root-user/organization/constants/status-badges";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type OrganizationStatus =
  | "NEW"
  | "ONBOARDING"
  | "GESTATING"
  | "LIVE"
  | "DEAD"
  | "TEST";

interface StatusSelectProps {
  /**
   * The currently selected status
   */
  value: OrganizationStatus;
  /**
   * Callback when status changes
   */
  onValueChange: (value: OrganizationStatus) => void;
  /**
   * Optional ID for the select trigger
   */
  id?: string;
  /**
   * Optional placeholder text
   */
  placeholder?: string;
  /**
   * Optional className for the select trigger
   */
  className?: string;
  /**
   * Optional disabled state
   */
  disabled?: boolean;
}

const STATUSES: OrganizationStatus[] = [
  "NEW",
  "ONBOARDING",
  "GESTATING",
  "LIVE",
  "DEAD",
  "TEST",
];

/**
 * A reusable status select component that displays statuses with consistent styling
 */
export function StatusSelect({
  value,
  onValueChange,
  id,
  placeholder = "Select Status",
  className,
  disabled,
}: StatusSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        id={id}
        className={className}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <SelectValue placeholder={placeholder}>
          {value && (
            <Badge
              variant="outline"
              className={cn("capitalize", STATUS_BADGE_STYLES[value])}
            >
              {value}
            </Badge>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {STATUSES.map((status) => (
          <SelectItem
            key={status}
            value={status}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <Badge
              variant="outline"
              className={cn("mr-2 capitalize", STATUS_BADGE_STYLES[status])}
            >
              {status}
            </Badge>
            {status}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
